import "./Features.css";

const features = [
  {
    title: "Experienced Dentist",
    text: "Years of trusted dental experience.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
        <path d="M12 3c2.2 3.2 3.2 5.2 3.2 7.2a3.2 3.2 0 1 1-6.4 0C8.8 8.2 9.8 6.2 12 3z" />
        <path d="M8.2 14.2C6 14.8 4 16.4 4 18.4 4 20.4 7.6 21.5 12 21.5s8-1.1 8-3.1c0-2-2-3.6-4.2-4.2" />
      </svg>
    ),
  },
  {
    title: "Advance Treatment",
    text: "Modern dentistry solutions.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
        <path d="M12 21c-4.5-2.4-8-6.2-8-11a8 8 0 1 1 16 0c0 4.8-3.5 8.6-8 11z" />
        <path d="M12 11v4M10 13h4" />
      </svg>
    ),
  },
  {
    title: "Guaranteed Results",
    text: "Reliable and lasting care.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
        <path d="M12 3 4.5 6.2v5.3c0 5 3.3 8.6 7.5 9.8 4.2-1.2 7.5-4.8 7.5-9.8V6.2L12 3z" />
        <path d="m9 12 2.1 2.1L15.5 10" />
      </svg>
    ),
  },
  {
    title: "Modern Equipment",
    text: "Latest dental technology.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
        <rect x="3" y="4" width="18" height="12" rx="2" />
        <path d="M8 20h8M12 16v4" />
      </svg>
    ),
  },
];

export default function Features() {
  return (
    <section className="features section">
      <div className="container">
        <h2 className="section-title">Complete Care on Your Schedule</h2>
        <div className="feature-grid">
          {features.map((feature) => (
            <article className="feature-card" key={feature.title}>
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
